"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const forms_constants_1 = require("@Const/forms-constants");
const react_1 = __importDefault(require("react"));
const ContactInfoSection = (props) => {
    const { userInfo, phoneNumberTitle } = props;
    return (react_1.default.createElement("section", { className: 'contact-info-section' },
        react_1.default.createElement("h5", null, "Contact Information"),
        react_1.default.createElement("div", { className: 'fields-row-container' },
            react_1.default.createElement("div", { className: 'field-block' },
                react_1.default.createElement("p", { className: 'small title' }, forms_constants_1.USER_FORM.phoneNumber.label),
                react_1.default.createElement("p", { className: 'value' }, phoneNumberTitle)),
            react_1.default.createElement("div", { className: 'field-block' },
                react_1.default.createElement("p", { className: 'small title' }, forms_constants_1.USER_FORM.email.label),
                react_1.default.createElement("p", { className: 'value' }, userInfo.email)))));
};
exports.default = ContactInfoSection;
